import { useState } from "react";
import { toast } from "sonner";
import { Loader2, CheckCircle2, Send } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

const useNewsletterSignup = () => {
    const [email, setEmail] = useState("");
    const [state, setState] = useState("idle"); // idle | sending | done

    const submit = async (e) => {
        e.preventDefault();
        setState("sending");
        try {
            const res = await fetch(`${API}/api/newsletter`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email }),
            });
            if (!res.ok) throw new Error("newsletter signup failed");
            setState("done");
            toast.success("You're subscribed — machine news is coming your way.");
        } catch {
            setState("idle");
            toast.error("Something went wrong — please try again.");
        }
    };

    return { email, setEmail, state, submit };
};

const SubscribedNote = () => (
    <p
        data-testid="newsletter-done"
        className="inline-flex items-center gap-2 text-sm text-[#C4956A] font-medium"
    >
        <CheckCircle2 size={15} /> You're on the list. Happy reading!
    </p>
);

export const NewsletterSignup = () => {
    const { email, setEmail, state, submit } = useNewsletterSignup();

    if (state === "done") return <SubscribedNote />;

    return (
        <form onSubmit={submit} className="flex items-center gap-2 max-w-sm">
            <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@email.com"
                data-testid="newsletter-email-input"
                className="flex-1 rounded-full bg-white/10 border border-white/20 px-4 py-2.5 text-sm text-[#FDF6EE] placeholder-[#FDF6EE]/40 focus:outline-none focus:ring-2 focus:ring-[#C4956A]/60 focus:border-[#C4956A]"
            />
            <button
                type="submit"
                disabled={state === "sending"}
                data-testid="newsletter-submit-btn"
                aria-label="Subscribe to newsletter"
                className="w-10 h-10 rounded-full bg-[#C4956A] text-white flex items-center justify-center hover:bg-[#A67C56] transition-colors disabled:opacity-60 flex-shrink-0"
            >
                {state === "sending" ? (
                    <Loader2 size={15} className="animate-spin" />
                ) : (
                    <Send size={15} />
                )}
            </button>
        </form>
    );
};
